import { render } from "./ManageLiveClass.vue?vue&type=template&id=1893e17c&scoped=true"
import script from "./ManageLiveClass.vue?vue&type=script&lang=js"
export * from "./ManageLiveClass.vue?vue&type=script&lang=js"

import "./ManageLiveClass.vue?vue&type=style&index=0&id=1893e17c&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1893e17c"]])

export default __exports__